import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DeleteModalComponent } from '@components/delete-modal/delete-modal.component';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { showNotification } from 'src/app/helpers/show-toast';
import { sortTable } from 'src/app/helpers/sort-table';
import { Branch } from 'src/app/_models/branch.model';
import { BranchService } from 'src/app/_services/branch.service';
import { CentersService } from 'src/app/_services/centers.service';
import { environment, baseUrl } from 'src/environments/environment';

@Component({
  selector: 'app-branches-per-lab-list',
  templateUrl: './branches-per-lab-list.component.html',
  styleUrls: ['./branches-per-lab-list.component.scss'],
})
export class BranchesPerLabListComponent implements OnInit {
  pageTitle: string;
  placeholder: string = 'Search by branch name …';
  branches: Branch[] = []; e;
  filteredBranches: Branch[] = [];
  branchName: string;
  invertSort: boolean = false;
  theadArray = [
    'Branch EN Name',
    'Branch AR Name',
    'Branch Phone',
    'Branch Email',
    'Branch Area',
    'Branch City',
    'Branch Address EN Name',
    'Branch Address AR Name',
    'Branch Active',
    'Branch Actions',
  ];
  modalRef: BsModalRef;
  labId: string;

  constructor(
    private branchService: BranchService,
    private centerService: CentersService,
    public toastr: ToastrService,
    private activatedRoute: ActivatedRoute,
    private modalService: BsModalService
  ) { }

  ngOnInit(): void {
    const centerId = this.activatedRoute.snapshot.params.centerId;
    this.labId = centerId;

    this.getCenterById(centerId);

    this.getBranchesBYCenterId(centerId);
  }

  getCenterById(id) {
    this.centerService.getCenterById(id).subscribe((res) => {
      this.branchName = res.data.name;
      this.pageTitle = `Branches in ${this.branchName ? this.branchName : "All"}`;
    });
  }

  getBranchesBYCenterId(id) {
    this.branchService.getBranchesBYCenterId(id).subscribe((res) => {
      res?.data?.branches.map((branch: Branch) => {
        branch.logo = `${branch.logo}`;
        this.branches.push(branch);
      });

      this.filteredBranches = [...this.branches];
    });
  }

  onSearchBranch(searchString) {
    if(searchString){
      this.branchService.searchByName(this.labId, searchString).subscribe((response) => {
        this.filteredBranches = response['data']['branches'];


      })
    }
  }

  onSearchInputKeyup(searchString) {
    if (!searchString) {
      this.filteredBranches = [...this.branches];
    }
    else{
       this.branchService.searchByName(this.labId, searchString).subscribe((response) => {
             this.filteredBranches = response['data']['branches'];

    })
    }

  }

  // onSearchInputKeyup(searchString) {
  //   if (!searchString) {
  //     this.filteredBranches = [...this.branches];
  //   }
  // }

  invertSorting() {
    this.invertSort = !this.invertSort;

    this.filteredBranches = sortTable(
      this.filteredBranches,
      'name',
      this.invertSort
    );
  }

  onBranchActiveChange(event, branch) {
    branch.isActive = event.target.checked;

    this.branchService.updateBranch(branch).subscribe((response) => {
      showNotification(
        'success',
        `${response['data'].name} branch is ${response['data'].isActive ? 'active' : 'not active'
        }`,
        this.toastr
      );
    });
  }

  onDeleteBranch(event, item): void {
    event.stopPropagation();

    const initialState: ModalOptions<any> = {
      keyboard: true,
      class: 'modal-dialog-centered modal-danger',
      initialState: {
        itemId: item.id,
        itemName: item.name,
      },
    };

    this.modalRef = this.modalService.show(DeleteModalComponent, initialState);

    this.modalRef.content.event.subscribe((data) => {
      this.onDeleteBranchSubmit(item.name, data);
    });
  }

  onDeleteBranchSubmit(branchName, branchId) {
    this.branchService.deleteBranch(branchId).subscribe((res) => {
      showNotification('success', `${branchName} branch has been deleted`, this.toastr);

      this.branches = this.branches.filter((branch) => branch.id !== branchId);

      this.filteredBranches = [...this.branches];

      this.modalRef.hide();
    });
  }
}
